/* tslint:disable: member-ordering */
import { Injectable } from '@angular/core';
import { ActionWithPayload } from '../../app.interfaces';

@Injectable()
export class ViewActions {
  static SET_LOADING = '[View] Change view';
  setLoading(isLoading: boolean): ActionWithPayload {
    return {
      type: ViewActions.SET_LOADING,
      payload: isLoading
    };
  }

  static SET_FULLSCREEN = '[View] Change fullscreen state';
  setFullscreen(isFullscreen: boolean): ActionWithPayload {
    return {
      type: ViewActions.SET_FULLSCREEN,
      payload: isFullscreen
    };
  }

  static CHANGE_VIEW = '[View] Change view';
  changeView(name: string): ActionWithPayload {
    return {
      type: ViewActions.CHANGE_VIEW,
      payload: name
    };
  }

  static PLAY_AUDIO = '[View] Play audio';
  playAudio(audio: Object): ActionWithPayload {
    return {
      type: ViewActions.PLAY_AUDIO,
      payload: audio
    };
  }

  static STOP_AUDIO = '[View] Stop audio';
  stopAudio(): ActionWithPayload {
    return {
      type: ViewActions.STOP_AUDIO
    };
  }

  static OPEN_MODAL = '[View] Open modal';
  openModal(modalContent: Object): ActionWithPayload {
    return {
      type: ViewActions.OPEN_MODAL,
      payload: modalContent
    };
  }

  static CLOSE_MODAL = '[View] Close modal';
  closeModal(): ActionWithPayload {
    return {
      type: ViewActions.CLOSE_MODAL
    };
  }

  static OPEN_MODAL_IMAGE = '[View] Open modal image';
  openModalImage(modalContent: Object): ActionWithPayload {
    return {
      type: ViewActions.OPEN_MODAL_IMAGE,
      payload: modalContent
    };
  }

  static CLOSE_MODAL_IMAGE = '[View] Close modal image';
  closeModalImage(): ActionWithPayload {
    return {
      type: ViewActions.CLOSE_MODAL_IMAGE
    };
  }

  static INSERT_ALERT = '[View] Insert alert';
  insertAlert(alert): ActionWithPayload {
    return {
      type: ViewActions.INSERT_ALERT,
      payload: alert
    };
  }

  static ADD_ALERT = '[View] Add alert';
  addAlert(alert): ActionWithPayload {
    return {
      type: ViewActions.ADD_ALERT,
      payload: alert
    };
  }

  static REMOVE_ALERT = '[View] Remove alert';
  removeAlert(alertId): ActionWithPayload {
    return {
      type: ViewActions.REMOVE_ALERT,
      payload: alertId
    };
  }

  static RESET_ALERT = '[View] Reset alert';
  resetAlerts(): ActionWithPayload {
    return {
      type: ViewActions.RESET_ALERT
    };
  }

  static SET_MODAL_LOADING = '[View] Set modal loading';
  setModalLoading(value): ActionWithPayload {
    return {
      type: ViewActions.SET_MODAL_LOADING,
      payload: value
    };
  }

  static AUDIO_EXT_STARTED = '[View] Audio ext started';
  audioExtStarted(): ActionWithPayload {
    return {
      type: ViewActions.AUDIO_EXT_STARTED,
      payload: null
    };
  }

  static AUDIO_EXT_ENDED = '[View] Audio ext ended';
  audioExtEnded(): ActionWithPayload {
    return {
      type: ViewActions.AUDIO_EXT_ENDED,
      payload: null
    };
  }

  static AUDIO_EXT_RESET_PLAY_ACCEPTED = '[View] Audio ext reset play accepted';
  audioExtResetPlayAccepted(): ActionWithPayload {
    return {
      type: ViewActions.AUDIO_EXT_RESET_PLAY_ACCEPTED,
      payload: null
    };
  }

  static AUDIO_EXT_PLAY_ACCEPTED = '[View] Audio ext play accepted';
  audioExtPlayAccepted(): ActionWithPayload {
    return {
      type: ViewActions.AUDIO_EXT_PLAY_ACCEPTED,
      payload: null
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/logics/view/view.actions.ts